/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizzazioneResDto } from '../../models/organizzazione-res-dto';

export interface OrganizzazioniControllerDeleteOrganizzazione$Params {
  idOrganizzazione: number;
}

export function organizzazioniControllerDeleteOrganizzazione(
  http: HttpClient,
  rootUrl: string,
  params: OrganizzazioniControllerDeleteOrganizzazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrganizzazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    organizzazioniControllerDeleteOrganizzazione.PATH,
    'delete',
  );
  if (params) {
    rb.path('idOrganizzazione', params.idOrganizzazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizzazioneResDto>;
      }),
    );
}

organizzazioniControllerDeleteOrganizzazione.PATH =
  '/admin/organizzazioni/id/{idOrganizzazione}';
